<template>
  <el-dialog
    :title="$t('text.remove_or_archive_patient')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    @close="closeDialog()"
    width="400px"
    class="edit-group"
  >
    <SelectPatient ref="selectPatient" />
    <div slot="footer" class="dialog-footer">
      <el-button
        class="common-btn min-w-80"
        @click="remove()"
        :loading="removeLoading"
        v-if="p('Patients.Delete')"
        >{{ $t('text.remove').toUpperCase() }}</el-button
      >
      <el-button
        class="common-btn min-w-80"
        @click="archive()"
        :loading="archiveLoading"
        v-if="p('Patients.Archive')"
        >{{ $t('text.archive').toUpperCase() }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import SelectPatient from '@/components/patients/quickActions/SelectPatient.vue'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      removeLoading: false,
      archiveLoading: false
    }
  },
  components: {
    SelectPatient
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.$refs.selectPatient.$refs.form.resetFields()
      this.dialogVisible = false
    },
    getSelectedPatientAlias() {
      let name
      this.$store.state.patient.patients.forEach(patient => {
        if (
          patient.patientId === this.$refs.selectPatient.form.selectedPatient
        ) {
          name = patient.alias
        }
      })
      return name
    },
    remove() {
      this.$refs.selectPatient.$refs.form.validate(valid => {
        if (valid) {
          let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
          this.$confirm(
            `<div class='warning-content'>${this.$t(
              'text.delete_patient_warning',
              {
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }
            )}</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
            this.$t('text.you_able_to_delete_data') +
              ' ' +
              this.getSelectedPatientAlias(),
            {
              confirmButtonText: this.$t('text.delete').toUpperCase(),
              cancelButtonText: this.$t('text.cancel').toUpperCase(),
              confirmButtonClass: 'confirm-btn',
              cancelButtonClass: 'cancel-btn',
              type: 'warning',
              customClass: 'delete-warning-box',
              showClose: true,
              closeOnClickModal: false,
              dangerouslyUseHTMLString: true
            }
          )
            .then(() => {
              this.handleDelete()
            })
            .catch(() => {})
        }
      })
    },
    handleDelete() {
      this.removeLoading = true
      ApiService.DeleteMemberShipPatient(
        this.$refs.selectPatient.form.selectedPatient
      )
        .then(response => {
          this.removeLoading = false
          if (response.data.success) {
            this.$store.dispatch('patient/fetchPatients')
            this.closeDialog()
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.deleted_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.removeLoading = false
        })
    },
    archive() {
      this.$refs.selectPatient.$refs.form.validate(valid => {
        if (valid) {
          this.$prompt('', this.$t('text.please_enter_comment'), {
            closeOnClickModal: false,
            confirmButtonText: this.$t('text.archive').toUpperCase(),
            cancelButtonText: this.$t('text.cancel').toUpperCase(),
            confirmButtonClass: 'danger-btn',
            inputType: 'textarea',
            inputValidator: input => {
              if (!input) {
                return this.$t('text.please_enter_comment')
              }
            }
          }).then(({ value }) => {
            this.handleArchive(value)
          })
        }
      })
    },
    handleArchive(comment) {
      this.archiveLoading = true
      ApiService.ArchivePatient({
        PatientId: this.$refs.selectPatient.form.selectedPatient,
        Comment: comment
      })
        .then(response => {
          this.archiveLoading = false
          if (response.data.success) {
            this.$store.dispatch('patient/fetchPatients')
            this.closeDialog()
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.archived_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.archiveLoading = false
        })
    }
  }
}
</script>
